import React from "react";
import { ExitRowProps } from "./types";

const ExitRow: React.FC<ExitRowProps> = ({ position }) => {
  return (
    <div
      className={`exit-row ${position === "left" ? "text-left" : "text-right"}`}
    >
      <span className="exit-icon px-2">Exit</span>
    </div>
  );
};

export default ExitRow;
